<template>
  <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.975 4.88162L8.25 9.08996L15.525 4.88162M8.25 17.4816V9.08162M15.75 12.415V5.74829C15.7497 5.45602 15.6725 5.16897 15.5263 4.91593C15.38 4.66289 15.1698 4.45276 14.9167 4.30662L9.08333 0.973291C8.82997 0.82701 8.54256 0.75 8.25 0.75C7.95744 0.75 7.67003 0.82701 7.41667 0.973291L1.58333 4.30662C1.33022 4.45276 1.11998 4.66289 0.973718 4.91593C0.827452 5.16897 0.7503 5.45602 0.75 5.74829V12.415C0.7503 12.7072 0.827452 12.9943 0.973718 13.2473C1.11998 13.5004 1.33022 13.7105 1.58333 13.8566L7.41667 17.19C7.67003 17.3362 7.95744 17.4132 8.25 17.4132C8.54256 17.4132 8.82997 17.3362 9.08333 17.19L14.9167 13.8566C15.1698 13.7105 15.38 13.5004 15.5263 13.2473C15.6725 12.9943 15.7497 12.7072 15.75 12.415Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
